import {nvText, locale, timeZone} from './nuvia-i18n.js';
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

// Riga calendar dates: no local DST or month-boundary arithmetic surprises.
export function deliveryRange(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {timeZone:timeZone,year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now);
  const get = /** @param {Intl.DateTimeFormatPartTypes} type */ type => Number(parts.find(part => part.type === type)?.value);
  const base = Date.UTC(get('year'), get('month') - 1, get('day'), 12);
  const fmt = new Intl.DateTimeFormat(locale, {day:'numeric',month:'long',timeZone:'UTC'});
  const start = new Date(base + 4 * 86400000);
  const end = new Date(base + 8 * 86400000);
  const first = start.getUTCMonth() === end.getUTCMonth() ? String(start.getUTCDate()) : fmt.format(start);
  return `${nvText('p_f814a0982a07')}${first}–${fmt.format(end)}`.toLocaleUpperCase(locale);
}
class MoDeliveryEstimate extends HTMLElement {
  connectedCallback() { this.update(); this.timer = setInterval(() => this.update(), 60000); }
  disconnectedCallback() { clearInterval(this.timer); }
  update() { this.textContent = deliveryRange(); }
}
if (!customElements.get('mo-delivery-estimate')) customElements.define('mo-delivery-estimate', MoDeliveryEstimate);

function celebrate() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate) return;
  const host = document.querySelector('#cart-drawer dialog[open]') || document.body;
  const layer = document.createElement('div');
  layer.setAttribute('aria-hidden','true');
  Object.assign(layer.style,{position:'fixed',inset:'0',pointerEvents:'none',overflow:'hidden',zIndex:'2147483646'});
  host.append(layer);
  const colors=['#243128','#96744e','#d8c5a7','#f0d8db'];
  for(let i=0;i<32;i++) {
    const dot=document.createElement('span');
    Object.assign(dot.style,{position:'absolute',left:'50%',top:'20%',width:'6px',height:'10px',background:colors[i%4],borderRadius:'2px'});
    layer.append(dot);
    dot.animate([{transform:'translate(0,0) rotate(0deg)',opacity:1},{transform:`translate(${(Math.random()-.5)*380}px,${160+Math.random()*260}px) rotate(${i*51}deg)`,opacity:0}],{duration:900+Math.random()*400,easing:'cubic-bezier(.12,.65,.35,1)',fill:'forwards'});
  }
  setTimeout(()=>layer.remove(),1400);
}
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
  if(event.action!=='add'||!event.promise)return;
  event.promise.then(result=>{if(!result?.detail?.didError)setTimeout(celebrate,180);}).catch(()=>{});
});

// The custom hero bypasses Tinker's product-form component. Bridge only that form.
// Native product forms, app forms, quantity changes and checkout remain untouched.
let adding = false;
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('olympe-product-hero-v12 .mo-form')||!document.getElementById('cart-drawer'))return;
  event.preventDefault();event.stopImmediatePropagation();
  if(adding)return;
  if(!form.reportValidity())return;
  adding=true;
  const button=/** @type {HTMLButtonElement | null} */ (form.querySelector('button[type="submit"]')), label=form.querySelector('[data-add-label]');
  const oldLabel=label?.textContent;
  const data=new FormData(form);
  const root=Theme.routes.cart_url.replace(/cart\/?$/,'');
  const base=root.endsWith('/')?root:root+'/';
  data.set('sections','cart-drawer-section');data.set('sections_url',location.pathname);
  form.querySelector('.mo-cart-add-error')?.remove();
  if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
  if(label)label.textContent=nvText('p_5b89f9861bc3');
  let accepted=false;
  try {
    const response=await fetch(base+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
    const result=await response.json();
    if(!response.ok||result.status)throw new Error(nvText('p_86eb33fcf192'));
    accepted=true;
    const cartResponse=await fetch(base+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!cartResponse.ok)throw new Error(nvText('p_40b97c08c35e'));
    const cart=await cartResponse.json();
    form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity')||1)}],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:result.sections,items:cart.items,source:'maison-olympe',didError:false}})}));
  } catch(error) {
    const message=document.createElement('p');message.className='mo-cart-add-error';message.setAttribute('role','alert');
    message.textContent=accepted?nvText('p_bde3bf3236a3'):nvText('p_1ba59a66b495');
    if(accepted){const link=document.createElement('a');link.href=base+'cart';link.textContent=nvText('p_b221e72b1350');message.append(link);}
    form.append(message);
  } finally {
    adding=false;
    if(button){button.disabled=false;button.removeAttribute('aria-busy');}
    if(label)label.textContent=oldLabel||nvText('p_21ba700763fb');
  }
},true);

// No cart countdown or automatic clearing in the Nuvia drawer.
try { localStorage.removeItem('maison-olympe:cart-expiry:v1'); } catch { /* Storage can be unavailable. */ }
